export default [
  { 
    path: 'create-new/', 
    name: 'InvoiceAdd',
    meta: { 
      title: 'Add Invoice',
      masterModal: 'create'
    }
  },
  {
    path: 'edit-new/:invoiceId',
    name: 'InvoiceEdit',
    meta: { 
      title: 'Edit Invoice',
      masterModal: 'edit'
    }
  },
  {
    path: 'view-new/:invoiceId',
    name: 'InvoiceView',
    meta: { 
      title: 'View Invoice',
      masterModal: 'view'
    }
  },
  {
    path: 'view-new/:invoiceId/recurrent',
    name: 'InvoiceViewRecurrent',
    meta: { 
      title: 'View Invoice',
      masterModal: 'view',
      recurrent: true
    }
  },
  {
    path: 'payment-new/:invoiceId',
    name: 'InvoicePayments',
    meta: { 
      title: 'Invoice payments',
      masterModal: 'payments'
    }
  },
  {
    path: 'send-new/', 
    name: 'InvoiceSendHomeNew',
    meta: { 
      title: 'Send Invoices',
      masterModal: 'send'
    },
    children: [
      { 
        path: ':invoiceId', 
        name: 'InvoiceSendNew',
        meta: { 
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
      { 
        path: ':invoiceId/:emailMessageId', 
        name: 'InvoiceSendNew',
        meta: { 
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
    ]
  },
  { // TODO remove this route when full release
    path: 'send/', 
    name: 'InvoiceSendHome',
    meta: { 
      title: 'Send Invoices',
      showInvoicesModal: true,
      modalType: 'send'
    },
    children: [
      { 
        path: ':invoiceId', 
        name: 'InvoiceSend',
        meta: { 
          title: 'Send Invoices',
          showInvoicesModal: true,
          modalType: 'send'
        }
      },
      { 
        path: ':invoiceId/:emailMessageId', 
        name: 'InvoiceSend',
        meta: { 
          title: 'Send Invoices',
          showInvoicesModal: true,
          modalType: 'send'
        }
      }
    ]
  },
  { 
    path: 'upload/', 
    name: 'InvoiceUpload',
    meta: { title: 'Upload to Invoices', showUploadModal: true, modalType: 'upload' } ,
    children: [
      { path: 'invoice/add', name: 'InvoiceUploadInvoice',
        meta: { 
          title: 'Upload Invoice',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'invoice' 
        } 
      },
      { path: 'correction/add', name: 'InvoiceUploadCorrection',
        meta: { 
          title: 'Upload Correction',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'correction'
        } 
      },
    ] 
  },
]
